import { twMerge } from "tailwind-merge";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@shared/ui/Button";
import { Article } from "../../support.types";

export type Props = {
  prev: Article | null;
  next: Article | null;
  onClick: (article: Article) => void;
};

export function SupportArticleNavigation({ prev, next, onClick }: Props) {
  if (!prev && !next) {
    return null;
  }

  return (
    <div
      className={twMerge(
        "flex justify-between w-full",
        !prev && "justify-end",
        !next && "justify-start"
      )}
    >
      {prev && (
        <Button
          variant="secondary"
          iconComponent={ChevronLeft}
          onClick={() => onClick(prev)}
          data-testid="support-article-prev"
        >
          {prev?.title}
        </Button>
      )}
      {next && (
        <Button
          variant="secondary"
          iconComponent={ChevronRight}
          iconPosition="right"
          onClick={() => onClick(next)}
          data-testid="support-article-next"
        >
          {next?.title}
        </Button>
      )}
    </div>
  );
}

export default SupportArticleNavigation;
